/**
 * generic api service interface
 */
import * as Marionette from 'backbone.marionette';

export default Marionette.Object.extend(
  {
    /** @type {Mutex} */
    mutex: null,

    /**
     * @param mutex {Mutex}
     */
    useMutex: function (mutex) {
      this.mutex = mutex;
    },

    /**
     * to be used from $ajax error handler to construct meaningful
     * promise rejection argument
     * @param jqXHR
     * @return {{error: string}}
     */
    createError(jqXHR) {
      let error = 'error';
      let errorCode = null;

      if (jqXHR) {
        errorCode = jqXHR.status;

        if (jqXHR.responseJSON) {
          const o = jqXHR.responseJSON;
          if (o.code && o.message) {
            error = `${o.code} - ${o.message}`;
          } else {
            error = jqXHR.responseText;
          }
        } else if (errorCode) {
          error = `${errorCode} - ${jqXHR.statusText}`;
        } else if (jqXHR.statusText) {
          error = jqXHR.statusText;
        }
      }

      return { error, errorCode };
    },
  },
  {
    // static
    synchronized(fn) {
      return function (...args) {
        if (this.mutex) {
          return this.mutex.synchronize(fn.bind(this, ...args));
        } else {
          return fn(...args);
        }
      };
    },
  }
);
